export const applicationDescriptionClassName =
  'font-sans text-[14px] font-medium leading-[140%] tracking-normal text-[#F4F4F4] md:mt-1 md:text-[20px] md:leading-[130%]';

export const applicationFootnoteClassName =
  'font-sans text-center text-[13px] font-normal leading-[20.8px] tracking-normal text-[#888C91]';

export const formLabelClassName =
  'font-sans text-base font-medium leading-[120%] tracking-normal text-[#898989]';

export const formInputClassName =
  'h-11 w-full rounded-[10px] border border-[#FFFFFF12] bg-[#FFFFFF] px-4 text-base font-medium leading-[120%] tracking-normal text-[#1B1D22] placeholder:font-medium placeholder:text-[#898989] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#A8EA3A]/40 md:h-[52px] md:px-5';

export const levelFieldTitleClassName =
  'font-sans text-base font-medium leading-[120%] tracking-normal text-[#888C91]';

export const levelOptionClassName =
  'flex cursor-pointer items-center justify-center rounded-[10px] border border-solid border-[#FFFFFF1A] bg-transparent px-3 text-center font-sans text-[14px] font-medium leading-[120%] tracking-normal text-[#898989] transition-colors has-[[data-state=checked]]:border-2 has-[[data-state=checked]]:border-[#A9F84A] has-[[data-state=checked]]:bg-[#A9F84A0F] has-[[data-state=checked]]:text-[#A8EA3A]';

export const checkboxLabelClassName =
  'font-sans text-[14px] font-normal leading-[140%] tracking-normal text-[#888C92]';

export const fieldErrorClassName = 'mt-1 font-sans text-[13px] leading-[120%] text-[#FF5053]';

export const submitButtonClassName =
  'flex h-[52px] w-full items-center justify-center rounded-[12px] bg-[#A9F84A] font-[440] text-base leading-[110%] tracking-normal text-[#1B1D22] transition-[filter] duration-200 hover:brightness-[0.92] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#A8EA3A]/50 disabled:cursor-not-allowed disabled:opacity-60';

export const checkboxClassName =
  'mt-0.5 border-[#888C91] data-[state=checked]:bg-[#A8EA3A] data-[state=checked]:text-[#1B1D22]';

export const inputErrorClassName = 'border-[#FF5053] ring-2 ring-[#FF5053]/30';

export const checkboxGroupErrorClassName = 'rounded-[10px] ring-2 ring-[#FF5053]/30';
